import script from "./HistoryLog.vue?vue&type=script&setup=true&lang=js"
export * from "./HistoryLog.vue?vue&type=script&setup=true&lang=js"

import "./HistoryLog.vue?vue&type=style&index=0&id=1876f247&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1876f247"]])

export default __exports__